module.exports = __webpack_public_path__ + "img/eye.660f471d.svg";